import Item from './Item.js';

export default class HeldItem extends Item {
    constructor({
        id,
        name,
        description,
        price,
        overworldOptions = ['Give', 'Cancel'],
        battleOptions = ['Cancel'],
    }) {
        super({ id, name, description, price, overworldOptions, battleOptions });
    }
}
